import React from "react";
import Navbar from "./Navbar";
import About from "./About";
import Projects from "./Projects";
import Contact from "./Contact";
import Work from "./Work";
import { Link, Element, scroller } from "react-scroll";
function Home() {
  const handleScroll = (to) => {
    scroller.scrollTo(to, {
      smooth: true,
      duration: 500,
    });
  };
  return (
    <>
      <Navbar />
      {/* Here we were using scrolling function but did not succedd  */}
      <Element name="about">
        <section>
          <About />
        </section>
      </Element>

      <Element name="Experience">
        <section>
          <Work />
        </section>
      </Element>
      <Element name="Projects">
        <section>
          <Projects />
        </section>
      </Element>
      <Element name="Contact">
        <section>
          <Contact />
        </section>
      </Element>
    </>
  );
}

export default Home;
